import styled from "styled-components";

type HomePageMainColProps = {
  bgColor?: string;
  border?: string;
  paddingLeft?: string;
};

type HomePageMainSectionProps = {
  bgImage?: string;
  sectionHeight?: number;
};

export const HomePageMainTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  & img {
    width: max-content;
  }

  & h2 {
    text-align: center;
    margin-bottom: 1rem;

    @media (min-width: 768px) {
      width: 70%;
    }
  }

  & button {
    margin-bottom: 2rem;
  }
`;

export const HomePageMainIcons = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-block-start: 4rem;
`;

export const HomePageMainSection = styled.section<HomePageMainSectionProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${({ bgImage }) => bgImage});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.6);
  min-height: ${({ sectionHeight }) => `${sectionHeight}vh`};

  div {
    display: flex;
    flex-direction: column;
    text-align: center;
    transform: translateY(-3rem);
  }

  h2 {
    font-size: 5.5rem;
    color: white;
  }

  p {
    color: white;
  }
`;

export const HomePageMainRow = styled.div<HomePageMainColProps>`
  display: flex;
  flex-wrap: wrap;

  & > div {
    flex: 1;  
    transform: translateY(-160px);
    padding: 4rem;

    @media (max-width: 768px) {
      flex-basis: 100%;
    }
  }

  & > div:first-child {
    button {
      margin-top: 2rem;
    }
  }

  & > div:last-child {
    h2 {
      color: white;
    }
  }

  @media (min-width: 769px) {
    & > div:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  
    & > div:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  @media (max-width: 768px) {
    & > div:first-child {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
  
    & > div:last-child {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
`;

export const HomePageMainCol = styled.div<HomePageMainColProps>`
  background-color: ${({ bgColor }) => bgColor || "#F5F5F5"};

  h2 {
    font-size: clamp(3rem, 5vw, 4rem);
    font-weight: 600;
    border-left: ${({border}) => border || ''};
    padding-left: ${({paddingLeft}) => paddingLeft};
    margin-bottom: 1rem;
  }
`;
